import { Card, Skeleton, Space } from 'antd'
import React from 'react'

const InvoiceProfileLoadingItems = ({ loading }) => {

    if (loading) {
        return (<Space direction="vertical" style={{ width: '100%' }}>
            <Card><Skeleton active paragraph={{ rows: 3 }} /></Card>
            <Card><Skeleton active paragraph={{ rows: 3 }} /></Card>
            <Card><Skeleton active paragraph={{ rows: 3 }} /></Card>
        </Space>)
    }
    


}

export default InvoiceProfileLoadingItems